import { Col, Divider, Form, Modal, notification, Row } from 'antd';
import classNames from 'classnames/bind';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import historyBookingAPI from '~/api/HistoryBooking';
import { SVGS } from '~/assets/assetsPath';
import OTPModal from '~/components/form-otp';
import CancelModal from '~/components/FormCancel';
import DoubleModal from '~/components/FormDouble';
import QRCodeModal from '~/components/QRCodeModal';
import firebase, { auth } from '~/service/firebase';
import styles from './LatestBooking.module.scss';

const cx = classNames.bind(styles);

const BookingContent = styled.div`
    .ant-divider-horizontal {
        margin: 0px;
    }
`;

function LatestBooking({ getHomeInformation, latestBooking, listNameService, ...props }) {
    const navigate = useNavigate();

    const userInfo = useSelector((state) => state.user.userInfo);
    const phone_booking = localStorage.getItem('phone_booking');

    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');

    const [isShowDoubleBooking, setIsShowDoubleBooking] = useState(false);
    const [isShowCancelBooking, setIsShowCancelBooking] = useState(false);
    const [isShowQRCode, setIsShowQRCode] = useState(false);

    const [isShowOTPModal, setIsShowOTPModal] = useState(false);

    const handleShowDoubleBookingModal = () => {
        setIsShowDoubleBooking(true);
    };
    const handleCloseDoubleBookingModal = () => {
        setIsShowDoubleBooking(false);
    };
    const onAgreeDoubleBooking = () => {
        setIsShowDoubleBooking(false);
        navigate(`/dat-lich-lai/${latestBooking?.id}`);
    };

    const handleShowCancelBookingModal = () => {
        setIsShowCancelBooking(true);
    };
    const handleCloseCancelBookingModal = () => {
        setIsShowCancelBooking(false);
    };
    const onAgreeCancelBooking = async () => {
        handleCancelBooking(latestBooking?.id);
        getHomeInformation();
        setIsShowCancelBooking(false);
        // if (isLogin) {
        //     handleCancelBooking(latestBooking?.id);
        //     getHomeInformation();
        //     setIsShowCancelBooking(false);
        // } else {
        //     sendOTPToPhone(userInfo?.phone || phone_booking);
        //     setIsShowCancelBooking(false);
        //     setIsShowOTPModal(true);
        // }
    };
    const handleCancelBooking = async (id) => {
        try {
            const res = await historyBookingAPI.cancelBookingAPI(id);
            if (res.code === 200) {
                notification.open({
                    message: 'Cancellation successful',
                    duration: 2,
                    placement: 'top',
                });
            }
        } catch (err) {
            console.log(err);
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
    };
    // Verify OTP
    const [formOTP] = Form.useForm();
    const [otp, setOtp] = useState('');
    const [errOtp, setErrOtp] = useState('');
    const [countErr, setCountErr] = useState(0);
    const defaultValuesOTP = {
        otp: null,
    };
    formOTP.setFieldsValue(defaultValuesOTP);
    const sendOTPToPhone = async (phone) => {
        if (phone.startsWith('0')) phone = `+84${phone.substring(1)}`;
        try {
            const appVerifier = window.recaptchaVerifier;
            auth.signInWithPhoneNumber(phone, appVerifier)
                .then((confirmationResult) => {
                    window.confirmationResult = confirmationResult;
                })
                .catch((err) => {
                    const errorFirebaseCheck = err.toString().split('/');
                    if (
                        errorFirebaseCheck[0] === 'Error: reCAPTCHA has already been rendered in this element' ||
                        errorFirebaseCheck[1] === 'too-many-requests).'
                    ) {
                        setErrOtp('Sending OTP exceeded the allowed limit, please try again later');
                    }
                });
        } catch (error) {
            console.log(error);
        }
    };
    const onFinishOTP = () => {
        try {
            if (otp.toString().length !== 6) {
                setErrOtp('Please enter OTP code');
            } else {
                if (otp?.length === 6) {
                    window.confirmationResult
                        .confirm(otp)
                        .then((confirmationResult) => {
                            //eslint-disable-next-line
                            // const { accessToken, phoneNumber } = confirmationResult.user._delegate;
                            // let phone = phoneNumber;
                            // if (phone.startsWith('+84')) phone = `0${phone.substring(3)}`;

                            handleCancelBooking(latestBooking?.id);
                            getHomeInformation();
                            setIsShowOTPModal(false);
                            setOtp('');
                        })
                        .catch((err) => {
                            const errorFirebase = err.toString().split('/')[1].slice(0, -2);

                            if (errorFirebase === 'invalid-verification-code') {
                                setErrOtp('Invalid OTP code');
                            }
                            const count = countErr + 1;
                            setCountErr(count);
                            if (count === 3) {
                                sendOTPToPhone(userInfo?.phone);
                                setCountErr(0);
                                setErrOtp('OTP code has just been sent back');
                            }
                        });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };
    const onChangeOtp = (val) => {
        setOtp(val);
        if (!val) {
            setErrOtp('Please enter OTP code');
        } else {
            setErrOtp('');
        }
    };

    const handleShowQRCodeModal = () => {
        setIsShowQRCode(true);
    };

    useEffect(() => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            size: 'invisible',
            callback: function (response) {},
            defaultCountry: 'VN',
        });
        //eslint-disable-next-line
    }, []);

    return (
        <div className={cx(props?.personalPage ? 'wrapper_personal' : 'wrapper')}>
            {props?.personalPage ? '' : <div className={cx('wrapper_title')}>Your booking</div>}
            <Row justify="center">
                <div className={cx('wrapper_container')}>
                    <BookingContent>
                        <Row align={props?.isDesktop ? 'middle' : 'start'} className={cx('header')}>
                            <Col xs={12}>
                                <Row align="middle" justify="start" className={cx('code_title')}>
                                    Booking code:
                                    {/* <span className={cx('code_service')}>#{latestBooking?.booking_code}</span> */}
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row align="middle" justify="end">
                                    <span className={cx('code_service')}>#{latestBooking?.booking_code}</span>
                                    {/* {latestBooking?.activity === 'WAITING' && (
                                        <span className={cx('status')}>Waiting for confirmation</span>
                                    )}
                                    {latestBooking?.activity === 'PROCESSING' && (
                                        <span className={cx('status')}>Confirmed</span>
                                    )}
                                    {(latestBooking?.activity === 'ASSIGNED' ||
                                        latestBooking?.activity === 'CONFIRMED') && (
                                        <span className={cx('status')}>Processing</span>
                                    )}

                                    {latestBooking?.activity === 'COMPLETED' && (
                                        <span className={cx('status')}>Completed</span>
                                    )}
                                    {latestBooking?.activity === 'CANCELED' && (
                                        <span className={cx('status')}>Canceled</span>
                                    )} */}
                                </Row>
                            </Col>
                        </Row>

                        <Divider />
                        <div className={cx('body')}>
                            <Row>
                                <div className={cx('item')}>
                                    <img src={SVGS.IconBodyPeople} alt="" />
                                    <span>
                                        {isLogin
                                            ? `${userInfo?.phone} ${
                                                  userInfo?.fullname ? `(${userInfo?.fullname})` : ''
                                              } `
                                            : phone_booking || ''}
                                    </span>
                                </div>
                            </Row>
                            <Row>
                                <div className={cx('item')}>
                                    <img src={SVGS.IconTimerBlack} alt="" />
                                    <span>
                                        {latestBooking?.time_start
                                            ? moment(new Date(parseInt(latestBooking?.time_start))).format(
                                                  'HH:mm, DD/MM/YYYY',
                                              )
                                            : null}
                                    </span>
                                </div>
                            </Row>
                            <Row>
                                <div className={cx('item')}>
                                    <img src={SVGS.IconPeoples} alt="" />
                                    <span>Beauty-ms will use the best staff for you</span>
                                </div>
                            </Row>
                            <Row align="middle">
                                <div className={cx('item')}>
                                    <img src={SVGS.IconBranch} alt="" />
                                    <span>Branch: {latestBooking?.branch?.name || ''}</span>
                                </div>
                            </Row>
                            {listNameService?.length ? (
                                <Row>
                                    <div className={cx('item')}>
                                        <img src={SVGS.IconServices} alt="" />
                                        <span>Service: {listNameService?.join(' - ')}</span>
                                    </div>
                                </Row>
                            ) : null}
                            <Row align="middle">
                                <div className={cx('item')}>
                                    <img src={SVGS.IconSpecialRequest} alt="" />
                                    <span>Special request: {latestBooking?.message || 'No'}</span>
                                </div>
                            </Row>
                        </div>
                        <Divider />
                        <Row className={cx('footer')}>
                            <Col xs={8}>
                                <Row justify="center">
                                    <div className={cx('btn')} onClick={handleShowDoubleBookingModal}>
                                        Reset
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={8}>
                                <Row justify="center">
                                    <div className={cx('btn')} onClick={handleShowCancelBookingModal}>
                                        Cancel appointment
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={8}>
                                <Row justify="center">
                                    <div className={cx('btn')} onClick={handleShowQRCodeModal}>
                                        QR Code
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </BookingContent>
                </div>
            </Row>
            <div id="recaptcha-container" visibility="hidden" data-size="invisible"></div>
            {isShowOTPModal && (
                <Modal
                    centered
                    visible={isShowOTPModal}
                    onCancel={() => {
                        setIsShowOTPModal(false);
                        formOTP.setFieldsValue(defaultValuesOTP);
                        setOtp('');
                    }}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <OTPModal
                            formOTP={formOTP}
                            onFinishOTP={onFinishOTP}
                            otp={otp}
                            onChangeOtp={onChangeOtp}
                            sendOTPToPhone={sendOTPToPhone}
                            errOtp={errOtp}
                            numPhone={userInfo?.phone || phone_booking}
                        />
                    </div>
                </Modal>
            )}
            {isShowDoubleBooking && (
                <Modal
                    centered
                    visible={isShowDoubleBooking}
                    onCancel={handleCloseDoubleBookingModal}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <DoubleModal
                            onRejectDouble={handleCloseDoubleBookingModal}
                            onAgreeDouble={onAgreeDoubleBooking}
                            text=" Do you want to reschedule this booking?"
                        />
                    </div>
                </Modal>
            )}
            {isShowQRCode && (
                <Modal
                    centered
                    visible={isShowQRCode}
                    onCancel={() => setIsShowQRCode(false)}
                    // closable={false}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <QRCodeModal setIsShowQRCodeModal={setIsShowQRCode} item={latestBooking} />
                </Modal>
            )}
            {isShowCancelBooking && (
                <Modal
                    centered
                    visible={isShowCancelBooking}
                    onCancel={handleCloseCancelBookingModal}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <CancelModal
                            onRejectCancel={handleCloseCancelBookingModal}
                            onAgreeCancel={onAgreeCancelBooking}
                            text="Do you want to cancel this booking?"
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
}

export default LatestBooking;
